import { render, staticRenderFns } from "./CookieStatement.vue?vue&type=template&id=663d442f&scoped=true"
import script from "./CookieStatement.vue?vue&type=script&lang=js"
export * from "./CookieStatement.vue?vue&type=script&lang=js"
import style0 from "./CookieStatement.vue?vue&type=style&index=0&id=663d442f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d442f",
  null
  
)

export default component.exports